<div class="quiz-result-dialog">
  <!-- Close Button -->
  <button class="close-btn" (click)="onClose()">&times;</button>

  <!-- Header -->
  <div class="header">
    <h2>Quiz Completed</h2>
    <p class="finished-time">Finished In: <span class="time-badge">{{ timeTaken }}</span></p>
  </div>

  <!-- Score Circle -->
  <div class="score-circle">
    <div class="circle-wrapper">
      <svg viewBox="0 0 120 120">
        <circle cx="60" cy="60" r="50" fill="none" stroke="#eee" stroke-width="10"></circle>
        <circle cx="60" cy="60" r="50" fill="none" stroke="#5a4fcf" stroke-width="10" stroke-dasharray="314"
          [attr.stroke-dashoffset]="314 - (314 * (score_percentage / 100))"></circle>
      </svg>
      <div class="circle-text">
        <span class="percent">{{ score_percentage }}%</span>
        <span class="label">Score</span>
      </div>
    </div>
  </div>
  <div class="points-box">
    <span>Points:</span>
    <strong> {{ gainedPoints }}/{{ totalQuestions }}</strong>
  </div>

  <div class="summary">
    <div class="top-grid">
    <div class="stat total">
      <div class="value">
        <img src="assets/images/album.svg" height="20" /> {{ totalQuestions }}
      </div>
      <div class="label">Total Questions</div>
    </div>
    <div class="stat not-answered">
      <div class="value">
        <img src="assets/images/unanswered.svg" height="20" /> {{ skippedAnswers }}
      </div>
      <div class="label">Not Answered</div>
    </div>
    <div class="stat partially-correct">
      <div class="value">
        <img src="assets/images/partial.svg" height="20" />
        {{ quizData?.overall_user_performance?.total_number_of_partial_correct_answer || 0 }}
      </div>
      <div class="label">Partially Correct</div>
    </div>
  </div>
  <div class="bottom-grid">
    <div class="stat correct">
      <div class="value">
        <img src="assets/images/task_alt_1.svg" height="20" /> {{ correctAnswers }}
      </div>
      <div class="label">Correct Answer</div>
    </div>
    <div class="stat wrong">
      <div class="value">
        <img src="assets/images/cancel.svg" height="20" /> {{ wrongAnswers }}
      </div>
      <div class="label">Wrong Answer</div>
    </div>
  </div>
  </div>

  <!-- Actions -->
  <div class="actions">
    <button mat-stroked-button color="primary" (click)="backToQuizPage()">
      <img src="assets/images/arrow_left_alt.svg" alt="Back Icon" height="20" class="me-1" />Back to Challenges
    </button>
    <button mat-flat-button color="primary" (click)="viewDetailedResult()">
      <img src="assets/images/visibility.svg" alt="Solutions Icon" height="20" class="me-1" />View Solutions
    </button>
  </div>
</div>